module.exports = __webpack_public_path__ + "img/about-us.07ffcf84.svg";